module.exports = __webpack_public_path__ + "media/Chest1200x1400.5ddbd2c6.webm";